"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KbActionTypes;
(function (KbActionTypes) {
    KbActionTypes["LoadMainEntityFieldNames"] = "kb.service load main entities";
    KbActionTypes["LoadMainEntityFieldNamesSuccess"] = "kb.service load main entities Success";
    KbActionTypes["LoadHierarchicalCategories"] = "kb.service load hierarchical categories";
    KbActionTypes["LoadHierarchicalCategoriesSuccess"] = "kb.service load hierarchical categories Success";
})(KbActionTypes = exports.KbActionTypes || (exports.KbActionTypes = {}));
//# sourceMappingURL=kb.actions.enum.js.map